<template>
	<div>
		<van-row class="bmTitle">
			<van-col span="24">
				<h2>交费管理</h2>
			</van-col>
		</van-row>
		<van-row class="bmForm">
			<van-col span="24" v-if="paymentList">
				<div v-if="paymentList.length == 0">
					<van-empty description="温馨提示：暂无未支付参会人。参会人如果已在待支付订单中，请在订单管理中进行支付或在订单管理中取消订单后，重新选择参会人进行交费支付。" />
				</div>
				<div v-else>
					<van-notice-bar style="font-size: 16px;" v-if="discountInfo">
						温馨提示：团体报名({{discountInfo.number}}人及以上)会议费优惠为{{discountInfo.price}}元/人
						<template #left-icon>
							<van-icon name='info-o' size="20" style="margin-right: 10px;" />
						</template>
					</van-notice-bar>
					<div>
						<van-checkbox-group v-model="enteredIds" ref="checkboxGroup" @change="change"
							style="padding-bottom: env(safe-area-inset-bottom);margin-bottom: 50px;">
							<van-cell-group>
								<van-cell v-for="(item,index) in paymentList" clickable :key="item.id"
									@click="toggle(index)">
									<template #title>
										{{item.name}} / {{item.phone}}
										<van-tag v-if="item.payStatus == 0" style="font-weight: normal;" type="danger"
											round plain>未支付</van-tag>
										</h2>
									</template>
									<template #right-icon>
										<van-checkbox :name="item.id" shape="square" ref="checkboxes" />
									</template>
								</van-cell>
							</van-cell-group>
						</van-checkbox-group>
						<div class="paayBottom flex-fill">
							<!-- <van-checkbox name="all" shape="square" v-model="checkedAll" ref="checkboxesAll"
								@change="allCheck" @click="allCheckClick" @click.stop>全选</van-checkbox> -->
							<span class="text">已选 <b>{{enteredList.length}}</b> 人</span>
							<span class="text">金额: <b>¥{{money}}</b> </span>
							<van-button type="danger" size="small" @click="payBtn">支付</van-button>
						</div>
					</div>
				</div>
			</van-col>
		</van-row>
	</div>
</template>
<script>
	import Global from '../Global/global.vue';
	import {
		areaList
	} from '@vant/area-data';
	export default {
		data() {
			return {
				paymentList: [],
				money: 0,
				isCheckAll: false,
				fpxxEndTime: '2025-02-02',
				checkedAll: false, //是否点击的是全选
				choiceZoneList: [], //选中的专区Item; 
				clickAll: false, //是否选择的全选按钮
				enteredIds: [], //弹出时选中的id
				enteredList: [],
				discountInfo:""
			};

		},
		created() {
			this.getNotPayEnteredList()
			this.toEnteredCenter()
		},
		methods: {
			toggle(index) {
				this.$refs.checkboxes[index].toggle();
			},
			change(val) { //更改选框
				//如果选中是否是全选，如果全选把所有都选中；
				//取消选中，看全选是否打开，如果是就去选全选的选择；   
				this.choiceZoneList = [];
				this.paymentList.map(item => { //更改
					if (val.includes(item.id)) this.choiceZoneList.push(item);
				})
				//判断选中的个数跟数据的个数是否一致，如果是一致，全选按钮为true,否则是false;
				if (val.length == this.paymentList.length) this.checkedAll = true;
				else {
					this.checkedAll = false;
					this.clickAll = false;
				}
				this.getTeamOrderDetail()
			},
			allCheck(e) {
				this.clickAll = true;
				//e会是true和false
				if (this.clickAll) this.$refs.checkboxGroup.toggleAll(e);
				//只有点击的全选按钮才把其他的checkbox做全选一样的操作；这里会触发change     
			},
			allCheckClick() { //点击全选
				this.clickAll = true;
			},
			payBtn() {
				const hyMeetingId = sessionStorage.getItem('meetingId');
				const token = localStorage.getItem('sessionGrzxToken_' + hyMeetingId);
				var data = {
					meetingId: hyMeetingId,
					enteredIds: this.enteredIds.join()
				}
				this.axios.post('/api/appweb/team/submitTeamOrder', data, {
					headers: {
						Authorization: ` ${token}`
					}
				}).then((res) => {
					const data = res.data.data;
					if (res.data.status == 200) {
						this.$cookies.set('cookies_meeting_order_payMoney', data.payMoney);
						this.$cookies.set('cookise_order_outTradeNo', data.outTradeNo);
						this.$router.push('/charge/pay');
					}
				})
			},
			//未支付用户信息
			getNotPayEnteredList() {
				const hyMeetingId = sessionStorage.getItem('meetingId');
				const token = localStorage.getItem('sessionGrzxToken_' + hyMeetingId);
				var data = {
					meetingId: hyMeetingId
				}
				this.axios.post('/api/appweb/team/getNotPayEnteredList', data, {
					headers: {
						Authorization: ` ${token}`
					}
				}).then(res => {
					if (res.data.status == 200) {
						this.paymentList = res.data.data;
					}
				})
			},
			toEnteredCenter() {
				var domain = window.location.host;
				//设置请求地址
				var http = "";
				if (domain.indexOf('127.0.0.1') > -1 || domain.indexOf('localhost') > -1 || domain.indexOf(
						'meeting.ejectu.com') == 0) {
					//域名
					http = "https://meeting.ejectu.com";
				}

				const hyMeetingId = sessionStorage.getItem('meetingId');
				const token = localStorage.getItem('sessionGrzxToken_' + hyMeetingId);

				if (!token) {
					this.$router.push('/personal/login?meetingId=' + hyMeetingId);
					return false;
				} else {
					this.axios.get('/api/appweb/entered/toEnteredCenter/' + hyMeetingId, {
						headers: {
							Authorization: ` ${token}`
						}
					}).then(res => {
						// console.log(res.data.data);
						if (res.data.status == 200) {
							if (res.data.data.meeting) {
								this.discountInfo = JSON.parse(res.data.data.meeting.discountInfo);
							}
						}
					});
				}
			},
			//实时计算应缴费金额
			getTeamOrderDetail() {
				const hyMeetingId = sessionStorage.getItem('meetingId');
				const token = localStorage.getItem('sessionGrzxToken_' + hyMeetingId);
				var data = {
					meetingId: hyMeetingId,
					enteredIds: this.enteredIds.join()
				}
				this.axios.post('/api/appweb/team/getTeamOrderDetail', data, {
					headers: {
						Authorization: ` ${token}`
					}
				}).then(res => {
					if (res.data.status == 200) {
						if (res.data.data != undefined) {
							if (res.data.data.allprice) {
								this.money = res.data.data.allprice;
							}
							if (res.data.data.enteredList) {
								this.enteredList = res.data.data.enteredList;
							}
						} else {
							this.money = 0;
							this.enteredList = [];
						}
					}
				})
			}
		},

		mounted() {

		}
	};
</script>

<style scoped="scoped">
	.paayBottom {
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 999;
		box-sizing: border-box;
		width: 100%;
		padding: 20px 16px 120px;
		padding-bottom: constant(safe-area-inset-bottom);
		padding-bottom: env(safe-area-inset-bottom);padding-bottom: 20px;
		background-color: #fff;
		border: 1px solid #ddd;
	}

	.paayBottom .van-button {
		padding: 16px 6%;
		float: right;
	}

	.paayBottom .van-checkbox {
		float: left;
		margin-top: 8px;
		width: 20%;
	}

	.paayBottom span.text {
		padding: 0 4px;
		float: left;
		margin-top: 6px;
	}

	.paayBottom span b {
		color: #ee0a24;
	}

	.bmForm {
		padding: 20px 0;
	}

	.bmTitle {
		padding: 0px 20px 10px;
		line-height: 40px;
		background: url(~@/assets/images/titlebg.png) no-repeat bottom center;
		background-size: 100% 100%;
		color: #fff;
		text-align: center;
	}

	.bmTitle h2 {
		font-weight: normal;
		font-size: 30px;
	}

	.formInput {
		padding: 4px 0;
		margin: 0 20px;
		border-bottom: 1px solid #e8e8e8;
	}

	.lineddd {
		height: 3px;
		background-color: #e8e8e8;
		margin-top: -1px;
	}

	.van-cell {
		padding: 20px 16px;
	}

	.van-cell,
	.van-button {
		font-size: 16px;
	}

	.van-cell::after {
		/* border-bottom: 0; */
	}

	.chmContent {
		position: relative;
		padding: 5px;
		width: 210px;
		margin: 20px auto 0;
	}

	.chmContent .chmewm {
		position: relative;
		padding: 4px;
		background: #fff;
		width: 202px;
	}

	.product-hover {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		-webkit-transition: opacity 0.3s ease;
		-moz-transition: opacity 0.3s ease;
		transition: opacity 0.3s ease;
		background-size: 30px 30px;
		background-image: -webkit-linear-gradient(45deg, rgba(234, 176, 176, 1) 25%, transparent 25%, transparent 50%, rgba(234, 176, 176, 1) 50%, rgba(234, 176, 176, 1) 75%, transparent 75%, transparent);
		background-image: -moz-linear-gradient(45deg, rgba(234, 176, 176, 1) 25%, transparent 25%, transparent 50%, rgba(234, 176, 176, 1) 50%, rgba(234, 176, 176, 1) 75%, transparent 75%, transparent);
		background-image: linear-gradient(45deg, rgba(234, 176, 176, 1) 25%, transparent 25%, transparent 50%, rgba(234, 176, 176, 1) 50%, rgba(234, 176, 176, 1) 75%, transparent 75%, transparent);
		-webkit-animation: barberpole 0.5s linear infinite;
		-moz-animation: barberpole 0.5s linear infinite;
		animation: barberpole 0.5s linear infinite;
	}

	@-webkit-keyframes barberpole {
		from {
			background-position: 0 0;
		}

		to {
			background-position: 60px 30px;
		}
	}

	@-moz-keyframes barberpole {
		from {
			background-position: 0 0;
		}

		to {
			background-position: 60px 30px;
		}
	}

	@keyframes barberpole {
		from {
			background-position: 0 0;
		}

		to {
			background-position: 60px 30px;
		}
	}

	.hide {
		display: none;
	}

	.beizhu {
		line-height: 30px;
		text-align: center;
		padding: 20px 0 0;
		color: #ee0a24;
		font-size: 14px;
	}

	.beizhu p {
		margin: 0
	}
</style>


// WEBPACK FOOTER //
// src/components/Personal/paymentmanagement.vue